export default __webpack_public_path__ + "assets/models/38c8e3fff91853c3f3612001ee1bd1ed.glb";